import './inputBox.sass'

export const InputBox = (placeholder:string, inputType: string, errorMsg?: string) => {
    return(
        <>
            <label className="inp" id={placeholder.replace(/\s/g, "")}>
                <input required type={inputType} placeholder="&nbsp;"/>
                <span className="label">{placeholder}</span>
                <span className="focus-bg"></span>
            </label>
        </>
    );
}

